import script from "./BodyMarker.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyMarker.vue?vue&type=script&setup=true&lang=ts"

import "./BodyMarker.vue?vue&type=style&index=0&id=55a6d872&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a6d872"]])

export default __exports__